import {ExpandMore} from '@mui/icons-material'

import {MenuSpan} from './NavMenuTrigger.styles'

const NavMenuTrigger = ({open, children, iconBefore: IconBefore, ...rest}) => (
  <MenuSpan {...rest}>
    <IconBefore />
    {children}
    <ExpandMore className='expand-icon' />
  </MenuSpan>
)

export default NavMenuTrigger
